module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 4.084","quantity":0.04084},{"color":"#9dc4b5","label":" 4.084- 7.35362","quantity":0.07354},{"color":"#e6efc3","label":" 7.35362- 8.63556","quantity":0.08636},{"color":"#ffe89e","label":" 8.63556- 10.2713","quantity":0.10271},{"color":"#f5af7f","label":" 10.2713- 12.3834","quantity":0.12383},{"color":"#ed6d32","label":" 12.3834- 24.93166","quantity":0.24932}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/maize_MME_1981_2016_lcr_100_return_20.json
// module id = 4iKm
// module chunks = 171